var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M853.333333 960H170.666667V64h469.333333l213.333333 213.333333z",
    fill: "#90CAF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.333333 298.666667H618.666667V96z",
    fill: "#E1F5FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 490.666667l-149.333333 213.333333h298.666666z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.333333 563.2L490.666667 704h213.333333z",
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672 522.666667m-32 0a32 32 0 1 0 64 0 32 32 0 1 0-64 0Z",
    fill: "#1976D2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLogo);
export default __webpack_public_path__ + "static/media/imageLogo.942d5023527063bded195758846aac0e.svg";
export { ForwardRef as ReactComponent };